/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyEvaluationNotification = {

	postInappropriateAssignmentNotification (context, agencyEvaluationNotificationDataDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-evaluation-notification/inappropriate-assignment-notification"
			, agencyEvaluationNotificationDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
